<script lang="ts">
	import type { BadgeColor } from '$lib/components/atoms/badge/types';
	import Badge from '$lib/components/atoms/badge/Badge.svelte';
	import * as m from '$paraglide/messages';
	import DatasheetDetailBlock from './DatasheetDetailBlock.svelte';

	export let strongPoints: string[];
	export let color: BadgeColor;
</script>

<DatasheetDetailBlock title={m.poi_datasheet__strong_points()}>
	<div class="flex flex-row flex-wrap gap-1">
		<!-- eslint-disable-next-line svelte/require-each-key -->
		{#each strongPoints as strongPoint}
			<Badge text={strongPoint} {color} />
		{/each}
	</div>
</DatasheetDetailBlock>
